
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { getPrefixFromString } from '@/helpers/booking';

extend('required', {
  ...required,
  message: 'This field is required',
});

@Component({
  components: {
    ValidationProvider,
  },
})
export default class LookupProductPrefix extends Vue {
  @Prop({ type: String, required: true }) public name: string;
  @Prop({ type: String, required: true }) public model: string;
  @Prop({ type: String, required: false, default: '' }) public variant: string;

  public prefixList = ['-', 'IN', 'OUT', 'OUT: RECYCLE', 'OUT: STORE', 'OUT: RETURN', 'OUT: WORKSHOP'];
  public prefixListShortList = {
    'OUT: RECYCLE': 'REC',
    'OUT: STORE': 'STO',
    'OUT: RETURN': 'RTN',
    'OUT: WORKSHOP': 'WS',
  };

  public loading = false;
  public prefixValue = '';
  public prefixValueToShow = '';
  public selectItems: string[] = [];
  public showOptions = false;
  public arrowIdx = -1;

  @Watch('model', { immediate: true })
  private watchPropTypeCode() {
    if (this.model.includes(':')) {
      this.prefixValue = getPrefixFromString(this.model);
    } else {
      this.prefixValue = '-';
    }
    // Show short names in the input
    if (Object.keys(this.prefixListShortList).includes(this.prefixValue.slice(0, -2))) {
      this.prefixValueToShow = this.prefixListShortList[this.prefixValue.slice(0, -2)];
    } else {
      this.prefixValueToShow = this.prefixValue;
    }
  }

  private applyValueFromParent(item): void {
    this.showOptions = false;
    this.prefixValue = item;
    this.$forceUpdate();
  }

  public handleInput(): void {
    this.arrowIdx = -1;
  }

  public inputKeyPressed(evt: KeyboardEvent): void {
    // Open dropdown on Focus
    if (!this.showOptions) {
      this.showOptions = true;
      this.arrowIdx = 0;
    }
    // Close dropdown when "Escape" pressed
    if (evt.code === 'Escape') {
      this.showOptions = false;
      this.arrowIdx = -1;
    }
    // ArrowDown / ArrowUp pressed
    if (evt.code === 'ArrowDown' && this.arrowIdx < this.prefixList.length - 1) {
      this.arrowIdx += 1;
      this.fixScrolling();
    }
    if (evt.code === 'ArrowUp' && this.arrowIdx >= 1) {
      this.arrowIdx -= 1;
      this.fixScrolling();
    }
    // Enter pressed
    if (evt.code === 'Enter' && this.arrowIdx >= 0) {
      evt.preventDefault();
      const item = this.prefixList[this.arrowIdx];
      this.showOptions = false;
      this.$emit('changed', item);
    }
  }

  private fixScrolling() {
    const options = this.$refs.options as HTMLFormElement;
    const scrollContainer = this.$refs.scrollContainer as HTMLFormElement;
    if (options && scrollContainer) {
      const liH = options[this.arrowIdx].clientHeight;
      scrollContainer.scrollTop = liH * this.arrowIdx;
    }
  }

  public inputFocused(): void {
    this.showOptions = true;
  }

  public inputBlured(): void {
    setTimeout(() => {
      this.showOptions = false;
    }, 200);
  }

  public handleItemClick(item: string): void {
    this.$emit('changed', item);
    this.showOptions = false;
  }

  public clickedOutside(): void {
    this.showOptions = false;
  }
}
